export default __webpack_public_path__ + "6bcff901191e9f9b483b873eb6f40003.svg";